import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { translate } from '../../../i18n';
import { GAME_QUERY_KEY } from './useGetGame';

type ReplacementLinkResponse = {
  token: string;
  link: string;
};

export const useGenerateReplacementLink = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const apiClient = useApiClient();

  return useMutation({
    mutationFn: async (gameId: number) => {
      return apiClient.fetchApi<ReplacementLinkResponse, {}>({
        endpoint: `payments/admin/replacement-request/game/${gameId}`,
        method: 'POST',
        body: {},
      });
    },
    onSuccess: (data, gameId) => {
      // Copy link to clipboard
      navigator.clipboard?.writeText(data.link).catch(() => {});

      toast({
        title: translate('game.replacement_link_generated'),
        description: data.link,
        status: 'success',
        duration: 10000,
        isClosable: true,
      });

      queryClient.invalidateQueries({ queryKey: GAME_QUERY_KEY(gameId) });
      // #14: Also invalidate game list — the API may have canceled an UPCOMING game
      queryClient.invalidateQueries({ queryKey: ['games', 'latest-booked'] });
    },
    // #15: Removed per-mutation onError — global MutationCache.onError handles it.
    // Having both produced double error toasts.
  });
};
